(function(){
if(window.__wvbInit){return}
window.__wvbInit=1;
document.addEventListener('click',function(e){
 var b=e.target.closest('.wvb-rm');
 if(!b){return}
 e.preventDefault();
 if(b.disabled){return}
 var keys=(b.getAttribute('data-wvb-keys')||'').split(',').filter(Boolean);
 if(!keys.length){return}
 b.disabled=true;
 b.textContent='Removing...';
 var d=b.closest('cart-drawer');
 fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
  var body={updates:c.items.map(function(it){return keys.indexOf(it.key)>-1?0:it.quantity})};
  if(d&&d.getSectionsToRender){body.sections=d.getSectionsToRender().map(function(s){return s.id}).join(',');body.sections_url=window.location.pathname}
  return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
 }).then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})}).then(function(res){
  if(!res.ok){throw new Error('update failed')}
  if(d&&d.renderContents&&res.j.sections){d.classList.toggle('is-empty',res.j.item_count===0);d.renderContents(res.j);if(window.freeShippMsg){window.freeShippMsg()}}
  else{window.location.reload()}
 }).catch(function(){b.disabled=false;b.textContent='Remove bundle'});
});
})();


(function(){
if(window.__fepInit){return}
window.__fepInit=1;
var busy=false,t;
function check(){
 if(busy||!document.querySelector('.fep-line, [href*="10ml-free-with-pod-kit"]')){return}
 busy=true;
 fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
  var kits={};
  c.items.forEach(function(i){if(i.product_id!==15950225211775&&(!i.properties||i.properties._free_with_kit!=='yes')){kits[i.product_title]=(kits[i.product_title]||0)+i.quantity}});
  var used={},updates={},n=0;
  c.items.forEach(function(i){var p=i.properties||{};
   if(i.product_id===15950225211775&&p._free_with_kit!=='yes'){updates[i.key]=0;n++;return}
   if(p._free_with_kit!=='yes'){return}
   var t=p['Free with'],left=(kits[t]||0)-(used[t]||0),keep=Math.max(0,Math.min(i.quantity,left));
   used[t]=(used[t]||0)+keep;
   if(keep!==i.quantity){updates[i.key]=keep;n++}
  });
  if(!n){busy=false;return}
  var d=document.querySelector('cart-drawer');
  var body={updates:updates};
  if(d&&d.getSectionsToRender){body.sections=d.getSectionsToRender().map(function(s){return s.id}).join(',');body.sections_url=window.location.pathname}
  return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})}).then(function(res){
   if(!res.ok){busy=false;return}
   if(d&&d.renderContents&&res.j.sections){d.classList.toggle('is-empty',res.j.item_count===0);d.renderContents(res.j);if(window.freeShippMsg){window.freeShippMsg()}busy=false}
   else{window.location.reload()}
  });
 }).catch(function(){busy=false});
}
new MutationObserver(function(){clearTimeout(t);t=setTimeout(check,300)}).observe(document.body,{childList:true,subtree:true});
check();
})();
